import axios from "axios";
import Cookies from "js-cookie";
import { FIRMFLOWURL } from "../url";
export const createClientServiceSubscriptionTask = (clientSubscriptionId, task) => {
  console.log("createClientServiceSubscriptionTask", clientSubscriptionId);
  return new Promise(async (resolve) => {
    try {
      const token = Cookies.get("Bearer");
      const response = await axios.post(
        `${FIRMFLOWURL}api/ClientServiceSubscriptionTask/ClientServiceSubscription/${clientSubscriptionId}`,
        {
          ...task,
        },
        {
          headers: { Authorization: token },
        }
      );
      resolve({ success: true, ...response });
    } catch (err) {
      console.log(err);
      if (err.message.includes(401)) {
        Cookies.remove("Bearer");
        window.location.replace("/");
        return;
      }
      resolve({ success: false, message: err.response.data.title });
    }
  });
};
